import React from "react";

const EditIcon = (props: any) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>edit-icon</title>
      <path
        d="M14 16H2c-1.105 0-2-.895-2-2V2C0 .895.895 0 2 0h8.41l-.835.836L8.415 2H2v12h12V7.547l1.146-1.145.854-.854V14c0 1.105-.895 2-2 2zm-1.57-9.7L9.97 8.76c-.31.284-.682.495-1.087.615l-2.4.6c-.135.06-.293.03-.397-.076-.104-.105-.134-.263-.075-.398l.6-2.4c.12-.405.33-.777.617-1.088l2.46-2.46 1.824-1.822 2.748 2.746L12.43 6.3zm2.71-2.706L12.39.848l.275-.274c.49-.49 1.206-.682 1.876-.503.672.18 1.195.704 1.375 1.375.18.67-.012 1.385-.503 1.876l-.273.274z"
        fill="#000"
        fillRule="evenodd"
      />
    </svg>
  );
};

export default EditIcon;
